import { LitElement } from 'lit';

class FitReviewList extends LitElement {
  static get is() { return 'fit-review-list'; }

  static get properties() {
    return {
      dataUrl: {
        type: String,
        attribute: 'data-url',
      },
      ratingUrl: {
        type: String,
        attribute: 'rating-url',
      },
    };
  }

  // No shadow dom necessary
  createRenderRoot() { return this; }

  constructor() {
    super();
    this.dataUrl = '';
    this.ratingUrl = '';
  }

  connectedCallback() {
    const sortByField = this.querySelector('#sortBy');

    sortByField.addEventListener('change', () => {
      const sortBy = sortByField.value;
      const take = this.querySelectorAll('.review-list__review').length;

      fetch(`${this.dataUrl}${sortBy}/${take}/${take}/`)
        .then((data) => data.text())
        .then((html) => this.querySelector('#ratingListData').innerHTML = html);
    });

    this.addEventListener('fit-vote-changed', (event) => {
      const data = {
        ratingId: event.detail.code.replace(/\D/g, ''),
        ratingLike: event.detail.vote === true,
        ratingDislike: event.detail.vote === false,
      };

      fetch(this.ratingUrl, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      });
    });
  }
}

customElements.define(FitReviewList.is, FitReviewList);
